/**
 * 代表幻燈片的一個頁面
 */
class SlideScene{
  /**
   * @param {SlideScene} opts
   */
  constructor(opts = {}){
    /**
     * 子標題
     * @type {String}
     */
    this.subtitle = opts.subtitle || null
    /**
     * 背景相關設定
     * @typedef {Object} BackgroundSettings
     * @property {string} type 可為 color | image
     * @property {string} value 根據 type 的不同具有不同意義, type=color: 色碼, type=image: 圖片連結
     */
    /**
     * @type {BackgroundSettings}
     */
    this.background = opts.background || {}
    this.background.type = this.background.type || 'color'
    this.background.value = this.background.value || '#333'

    /**
     * 字體相關設定
     * @typedef {Object} FontSettings
     * @property {string} color 文字顏色
     * @property {string} size 文字大小
     */
    /**
     * @type {FontSettings}
     */
    this.font = opts.font || {}
    this.font.color = this.font.color | 'white'
    this.font.size = this.font.size | 'auto'

    /**
     * 顯示的文字內容
     * @type {string}
     */
    this.content = opts.content || ''
    /**
     * TTS要說出的文字內容 (若為 null 則使用 this.content)
     * @type {?string}
     */
    this.speech = opts.speech || null
  }
}
module.exports = SlideScene
